export default "__VITE_ASSET__CVd2z3iO__"